import { PurchaseAction } from '@/constants';
import type { PurchaseActionType } from '@/types';

export const getButtonLabel = (purchaseAction?: PurchaseActionType) => {
  if (purchaseAction === PurchaseAction.BackOrder) {
    return 'Back-order';
  }

  if (purchaseAction === PurchaseAction.Notify) {
    return 'Notify me';
  }

  if (purchaseAction === PurchaseAction.PreOrder) {
    return 'Pre-order';
  }

  return 'Add to cart';
};
